/*!
=========================================================
* HIVEPlace - Prova de Vida - v1.0.0
=========================================================

* Product Page: https://liveness.hiveplace.com.br/
* Copyright 2024 HIVEPlace (https://www.hiveplace.com.br)
* Coded by www.hiveplace.com.br
=========================================================
*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Plugins from './plugins/plugins-kit'
import store from './store'
import i18n from './i18n'
import './registerServiceWorker'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

import '@identy/identy-face/dist/identy-face-style.css'

import './permission'

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DNS,
  sendDefaultPii: true,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', 'hiveplace.com.br', /^\//]
    })
  ],
  // Tracing
  tracesSampleRate: 1.0,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/hiveplace\.com\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true
})

Vue.config.productionTip = false
Vue.use(Plugins)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
